export default __webpack_public_path__ + "static/media/practice-test-8.67c2325a.csv";